export const getISO8601Date = (date, needTime = true) => {
  if (!date) return null;
  if (typeof date !== 'string') return new Date(date);
  const dateArr = date.split(' ');
  if (dateArr.length === 1) {
    dateArr.push('00:00:00');
  }
  if (!needTime) {
    dateArr[1] = '00:00:00';
  }
  return new Date(`${dateArr.join('T')}+08:00`);
};

export const formatDate = (date, needTime = false) => {
  if (!date) {
    return null;
  }
  const dateObj = getISO8601Date(date, needTime);
  const month = `0${dateObj.getMonth() + 1}`.slice(-2);
  const day = `0${dateObj.getDate()}`.slice(-2);
  const year = dateObj.getFullYear();
  if (needTime) {
    const hour = `0${dateObj.getHours()}`.slice(-2);
    const minute = `0${dateObj.getMinutes()}`.slice(-2);
    const second = `0${dateObj.getSeconds()}`.slice(-2);
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }
  return `${year}-${month}-${day}`;
};

export const addDays = (date, days) => {
  const dateObj = getISO8601Date(date);
  dateObj.setDate(dateObj.getDate() + days);
  return dateObj;
};

const now = new Date(); // 當前日期
const nowDayOfWeek = now.getDay(); // 今天本週的第幾天
const nowDay = now.getDate(); // 當前日
const nowMonth = now.getMonth(); // 當前月
const nowYear = now.getFullYear(); // 當前年
const lastMonthDate = new Date(); // 上月日期
lastMonthDate.setDate(1);
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
const lastMonth = lastMonthDate.getMonth(); // 上一月

// 獲得某月的天數
export const getMonthDays = (myMonth) => {
  const monthStartDate = new Date(nowYear, myMonth, 1);
  const monthEndDate = new Date(nowYear, myMonth + 1, 1);
  const days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
  return days;
};
// 獲得本季度的開端月份
export const getQuarterStartMonth = () => {
  let quarterStartMonth = 0;
  if (nowMonth < 3) {
    quarterStartMonth = 0;
  }
  if (nowMonth > 2 && nowMonth < 6) {
    quarterStartMonth = 3;
  }
  if (nowMonth > 5 && nowMonth < 9) {
    quarterStartMonth = 6;
  }
  if (nowMonth > 8) {
    quarterStartMonth = 9;
  }
  return quarterStartMonth;
};
// 獲得本週的開端日期
export const getWeekStartDate = () => {
  let weekStartDate;
  if (nowDayOfWeek === 0) {
    weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1 - 7);
  } else {
    weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
  }
  return weekStartDate;
};
// 獲得本週的停止日期
export const getWeekEndDate = () => {
  let weekEndDate;
  if (nowDayOfWeek === 0) {
    weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek) + 1 - 7);
  } else {
    weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek) + 1);
  }
  return weekEndDate;
};
// 獲得本月的開端日期
export const getMonthStartDate = () => {
  const monthStartDate = new Date(nowYear, nowMonth, 1);
  return monthStartDate;
};
// 獲得本月的停止日期
export const getMonthEndDate = () => {
  const monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth));
  return monthEndDate;
};
// 獲得上月開端時候
export const getLastMonthStartDate = () => {
  const lastMonthStartDate = new Date(nowYear, lastMonth, 1);
  return lastMonthStartDate;
};
// 獲得上月停止時候
export const getLastMonthEndDate = () => {
  const lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth));
  return lastMonthEndDate;
};
// 獲得本季度的開端日期
export const getQuarterStartDate = () => {
  const quarterStartDate = new Date(nowYear, getQuarterStartMonth(), 1);
  return quarterStartDate;
};
// 獲得本季度的停止日期
export const getQuarterEndDate = () => {
  const quarterEndMonth = getQuarterStartMonth() + 2;
  const quarterStartDate = new Date(nowYear, quarterEndMonth, getMonthDays(quarterEndMonth));
  return quarterStartDate;
};
